// Microsoft Advertising UET Tag
export const UET_TAG_ID = "211072785";

declare global {
  interface Window {
    uetq?: unknown[];
  }
}

let initialized = false;

export function initUet() {
  if (typeof window === "undefined" || initialized) return;
  initialized = true;

  window.uetq = window.uetq || [];
  const s = document.createElement("script");
  s.async = true;
  s.src = "//bat.bing.com/bat.js";
  s.onload = () => {
    const UET = (window as unknown as { UET?: new (o: unknown) => unknown }).UET;
    if (!UET) return;
    const o = {
      ti: UET_TAG_ID,
      enableAutoSpaTracking: true,
      q: window.uetq,
    };
    window.uetq = new UET(o) as unknown[];
    (window.uetq as { push: (...a: unknown[]) => void }).push("pageLoad");
  };
  document.head.appendChild(s);
}

export function trackUetPageView() {
  if (typeof window === "undefined") return;
  window.uetq = window.uetq || [];
  (window.uetq as unknown[]).push("event", "page_view", {});
}

/** Enhanced Conversions: gehashte Nutzerdaten an Microsoft übergeben. */
export function setUetPid(email?: string, phone?: string) {
  if (typeof window === "undefined") return;
  const pid: Record<string, string> = {};
  if (email) pid.em = email.trim().toLowerCase();
  if (phone) pid.ph = phone.replace(/[^\d+]/g, "");
  if (!Object.keys(pid).length) return;
  window.uetq = window.uetq || [];
  (window.uetq as unknown[]).push("set", { pid });
}

/** Lead-Conversion an Microsoft Advertising melden. */
export function trackUetLead(value = 3990, email?: string, phone?: string) {
  if (typeof window === "undefined") return;
  setUetPid(email, phone);
  window.uetq = window.uetq || [];
  (window.uetq as unknown[]).push("event", "generate_lead", {
    event_category: "lead",
    revenue_value: value,
    currency: "EUR",
  });
}
